<template>
    <v-dialog
        v-model="showDialog"
        width="600"
        style="z-index: 250"
    >
        <v-form
            ref="form"
            @submit.prevent="submitForm"
        >
            <v-card>
                <v-card-title style="background-color: #009688; color: white; word-wrap: normal;">
                    Request for extension
                </v-card-title>
                <v-card-text
                    v-if="info"
                    style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;"
                >
                    <p v-if="!isPortalActive" style="margin: 10px 0 5px 0; color: #ff5252">
                        Can't proceed with extension request unless portal status is active.
                    </p>
                    <v-text-field
                        v-model="portalStatus"
                        label="Portal Status"
                        persistent-hint
                        disabled
                    />
                    <v-text-field
                        v-model="formattedMaxDate"
                        label="Portal Active Until"
                        disabled
                    />
                    <v-text-field
                        v-model="formattedCurrentValidityDate"
                        label="Current Validity"
                        disabled
                    />
                    <v-text-field
                        ref="extensionDate"
                        v-model="date"
                        type="date"
                        :max="maxDate"
                        :min="minDate"
                        label="Extension Date"
                        :rules="[v=>!!v||'This field is required']"
                        persistent-hint
                        hint="Extension Date must not exceed the Portal Active Until"
                    />
                </v-card-text>
                <v-card-actions style="background-color: #EDFFFB;">
                    <v-spacer />
                    <v-btn
                        outlined
                        class="white--text"
                        color="teal darken-1"
                        style="text-transform: none; width: 105px;"
                        @click="showDialog = false"
                    >
                        CLOSE
                    </v-btn>
                    <v-btn
                        color="teal darken-1 white--text"
                        class="white--text"
                        style="text-transform: none; width: 105px; font-weight: 600"
                        :loading="loading"
                        type="submit"
                        :disabled="portalStatus === 'INACTIVE'"
                    >
                        SUBMIT
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { moment } from '../../../../../../../utils/date-shim'
export default {
    props: ['show', 'data', 'info', 'notif'],
    data: () => ({
        maxDate: null,
        loading: false,
        date: null
    }),
    computed: {
        ...mapGetters(['extendLetterData', 'getStatusProvisionData']),
        isPortalActive() {
            return this.portalStatus !== 'INACTIVE'
        },
        portalStatus() {
            if (this.getStatusProvisionData) {
                return this.getStatusProvisionData.data.STATUS
            }
            return null
        },
        formattedCurrentValidityDate() {
            if (this.info.LETTER_VALID_UNTIL) {
                return moment(this.info.LETTER_VALID_UNTIL).format('MMMM D, YYYY')
            }
            return null
        },
        minDate() {
            const now = moment()
            const old = moment(this.info && this.info.LETTER_VALID_UNTIL)
            const newDate = moment.max(now, old).format('YYYY-MM-DD')
            this.setDate(newDate)
            return newDate
        },
        accountNumber() {
            return this.info && this.info.ACCT_N
        },
        formattedMaxDate() {
            if (this.maxDate) {
                return moment(this.maxDate).format('MMMM D, YYYY')
            }
            return null
        },
        showDialog: {
            get() {
                if (this.accountNumber) {
                    this.getStatusProvision({ ACCT_N: this.accountNumber })
                }
                this.$nextTick(() => {
                    this.setDate(this.minDate)
                })
                return this.show
            },
            set() {
                this.resetForm()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        getStatusProvisionData(newVal) {
            this.maxDate = moment(newVal.data.ACTIVE_UNTIL).format('YYYY-MM-DD')
        },
        extendLetterData(newVal) {
            if (newVal && newVal.status === 201) {
                this.listEndorsementConfirmation()
                this.notif.type = 'success'
                this.notif.color = 'success'
                this.notif.timeout = 5000
                this.notif.msg = 'Letter extended until ' + this.formatDate(this.date)
                this.notif.show = true
                this.notif.dismissible = true
                this.$emit('closeDialogWhenSuccessExtension')
                this.showDialog = false
            } else {
                this.notif.type = 'error'
                this.notif.color = 'error'
                this.notif.timeout = 5000
                this.notif.msg = newVal.state
                this.notif.show = true
                this.notif.dismissible = true
            }
        }
    },
    methods: {
        ...mapActions(['extendLetter', 'listEndorsementConfirmation', 'getStatusProvision']),
        setDate(date) {
            this.date = date
        },
        formatDate(date) {
            return moment(date).format('MMMM D, YYYY')
        },
        submitForm() {
            if (this.$refs && this.$refs.form && this.$refs.form.validate())
                this.extendLetter({ ID: this.info.ID, ACU_END_DATE: this.date })
        },
        resetForm() {
            if (this.$refs && this.$refs.extensionDate)
                this.$refs.extensionDate.reset()
        }
    }
}
</script>
